"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessioncontactModel = void 0;
class SessioncontactModel {
    constructor(obj = null) {
        this.model = "SessioncontactModel";
        this.editorialContact = "";
        this.editorialEmail = "";
        this.editorialPhone = "";
        this.marketingContact = "";
        this.marketingEmail = "";
        this.marketingPhone = "";
        this.customercareContact = "";
        this.customercareEmail = "";
        this.customercarePhone = "";
        if (obj != null) {
            this.clone(obj);
        }
    }
    clone(obj) {
        this.editorialContact = obj.editorialContact;
        this.editorialEmail = obj.editorialEmail;
        this.editorialPhone = obj.editorialPhone;
        this.marketingContact = obj.marketingContact;
        this.marketingEmail = obj.marketingEmail;
        this.marketingPhone = obj.marketingPhone;
        this.customercareContact = obj.customercareContact;
        this.customercareEmail = obj.customercareEmail;
        this.customercarePhone = obj.customercarePhone;
    }
    static fromJson(d) {
        const sessionContactInstance = Object.assign(new SessioncontactModel(), typeof d === 'string' ? JSON.parse(d) : d);
        return sessionContactInstance;
    }
}
exports.SessioncontactModel = SessioncontactModel;
//# sourceMappingURL=sessioncontact.model.js.map